import { render, staticRenderFns } from "./CourseTextContent.vue?vue&type=template&id=f5dbb23c&scoped=true"
import script from "./CourseTextContent.vue?vue&type=script&lang=js"
export * from "./CourseTextContent.vue?vue&type=script&lang=js"
import style0 from "./CourseTextContent.vue?vue&type=style&index=0&id=f5dbb23c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dbb23c",
  null
  
)

export default component.exports